import React from "react";
import PropTypes from "prop-types";
import { css } from "@emotion/react";
import { FormattedMessage } from "react-intl";
import { Row } from "components/Containers";
import { colors, fontSize } from "style";

/**
 * ApplicantMissionLifetimeCount
 *
 * @param {Object} data
 */
const ApplicantMissionLifetimeCount = ({ data }) => (
  <Row gap="0.4rem" noWrap>
    <FormattedMessage
      id="Missions.Applicants.ApplicantMissionLifetimeCount"
      values={{
        count: <div css={styles.icon_container}>{data?.missionCount}</div>,
      }}
    />
  </Row>
);

const styles = {
  icon_container: css`
    border-radius: 1rem;
    background: ${colors.grayAnatomyLight3};
    font-size: ${fontSize.xxsmall};
    width: 3.5rem;
    height: 2rem;
    display: flex;
    justify-content: center;
    align-items: center;
  `,
};

ApplicantMissionLifetimeCount.propTypes = {
  data: PropTypes.shape({
    missionCount: PropTypes.number,
  }).isRequired,
};

export default ApplicantMissionLifetimeCount;
